import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, RouterStateSnapshot, UrlTree, Router } from '@angular/router';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { AppGuard } from './app.guard';
import { environment } from '../../environments_mc/environment';
import { LoggingService } from '../utility/platform/logging.service';
import { SystemEnvironment } from '@mono-repo/data';

@Injectable({
  providedIn: 'root',
})
export class LoginGuard implements CanActivate {
  private redirectUrl: UrlTree = this.router.parseUrl('/cockpit');

  constructor(
    private router: Router,
    private appGuard: AppGuard,
    private logging: LoggingService,
  ) {}

  public canActivate(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot,
  ): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
    return this.appGuard.canActivate(next, state).pipe(
      map((response) => {
        if (response === true) {
          if (localStorage.getItem('isLoggedIn')) {
            if (environment.systemEnvironment != SystemEnvironment.APP) {
              sessionStorage.setItem('tokenForLoggingOfUserSessions', this.logging.generateRandomToken());
              sessionStorage.setItem('loginTime', new Date().toISOString());
              this.logging.sendUserTrackingLogs().subscribe();
            } else {
              if (localStorage.getItem('isUnlocked')) {
                sessionStorage.setItem('tokenForLoggingOfUserSessions', this.logging.generateRandomToken());
                sessionStorage.setItem('loginTime', new Date().toISOString());
                this.logging.sendUserTrackingLogs().subscribe();
              }
            }
            return this.redirectUrl;
          } else {
            return true;
          }
        } else {
          return response;
        }
      }),
    );
  }
}
